import * as React from 'react'
import { Alert, Col, Container, Form, ProgressBar, Spinner } from 'react-bootstrap'
import * as _ from 'lodash'

import axios from 'axios'

import IosArrowForward from 'react-ionicons/lib/IosArrowForward'

import { copyObject } from '../../components/TimerView'
import { isEmail, isValidName } from '../../utils/validator'
import { withQuery } from '../../utils'
import config from '../../constants/config'
import { useImmer } from 'use-immer'

import { AxiosInstance, unauthorizedRequest } from '../../utils/RequestMethods'
import ScreenPasswordReset from './ScreenPasswordReset'

import ButtonLoading from '../../components/ButtonLoading/ButtonLoading'
import { ClientT } from '../../types/Users'
import { Button } from '@mui/material'
import { asyncLoginSuccess } from '../../redux/actions'
import { useDispatch } from 'react-redux'



const styles = {
  left: {
    marginLeft: 0
  },
  required: {
    color: 'red'
  }
}


export interface FieldsClientIntroT {
  email: string
  password: string
}
export type IScreenClientIntroProps = {
  token: string
  nextScreen(fields: FieldsClientIntroT, emailNotFound: boolean, tokenUser: string, client?: ClientT): void
  handle?: string
}

const ScreenClientIntro: React.FC<IScreenClientIntroProps> = (props) => {
  const [validated, setValidated] = React.useState<boolean>(false)

  const [processing, setProcessing] = React.useState<boolean>(false)
  // const [jobs, setJobs] = React.useState([])
  const [emailNotFound, setEmailNotFound] = React.useState(true)
  const [restPassword, setRestPassword] = React.useState(false);
  const dispatch = useDispatch()
  const [fields, setFields] = useImmer({
    email: "",
    password: ""
  })

  const delayedQuery = React.useRef(_.debounce((q, token) => emailAvailable(q, token, props.handle), 1000)).current;
  const formRef = React.useRef(null)
  const emailAvailable = async (email: string, token: string, handle: string = null): Promise<any> => {
    setProcessing(true)
    try {
      let params = {
        handle: handle, // company handle
        email: email
      }
      const options = {
        headers: { 'Authorization': `Bearer ${token}` },
      }
      let url = `${config.url.emailAvailable}`
      let res = await AxiosInstance.post(url, params, options)
      if (res && res.data) {
        setEmailNotFound(true)
      }
      setProcessing(false)
    }
    catch (error) {
      setEmailNotFound(false)
      setProcessing(false)

    }
  }


  const onChangeFields = (key: string, value: any) => {
    setFields((draft) => {
      draft[key] = value
    })
  }




  /**
   *
   * @returns
   */
  const submitLogin = async (email: string, password: string): Promise<string> => {
    let params = {
      email: email,
      password: password,
    };

    return await AxiosInstance.post(`${config.url.wpJson}/wp/v2/token`, params).then((res) => {
      if (res && res.data) {

        dispatch(asyncLoginSuccess(res.data))

        setTimeout(() => {
          nextScreen(res.data.token)
        }, 50);
        return 'Login in.'
      }
    }).catch((error) => {
      throw error;
    })
  }



  const nextScreen = async (token): Promise<void> => {
    let options = {
      // data: params,
      headers: {
        'Authorization': `Bearer ${token}`
      }
    }
    AxiosInstance.get(`${config.url.me}`, options).then((res) => {
      if (res && res.data) {
        props.nextScreen(fields, emailNotFound, token, res.data)
      }
    }).catch((error) => {
      throw error;
    })
  }

  /**
   *
   * @param email
   * @returns
   */
  const forgotPassword = async (email: string): Promise<string> => {
    if (!isEmail(email)) {
      throw new Error("You must input a valid email.");

    }
    let params = {
      email: email,
    };
    return AxiosInstance.post(`${config.url.token}/password/lost`, params).then((res) => {
      if (res && res.data) {

        setTimeout(() => {
          setRestPassword(true)
        }, 500);

        return 'Reset password check your email.'
      }
    }).catch((error) => {
      throw error;
    })
  }
  const checkValidity = () => {
    if (formRef && formRef.current) {
      let validityForm = formRef.current.checkValidity();
      return validityForm
    }
    return false
  }

  if (restPassword) {
    return (
      <ScreenPasswordReset
        email={fields.email}
        goBack={() => {
          setRestPassword(false)
        }} />
    )
  }
  return (
    <div>
      <p className='text-muted mb-3'>Input your email to start or continue booking a job.</p>
      <hr className='mt-0' />
      <Form noValidate ref={formRef} validated={validated}>

        {/* Email field */}
        <Form.Group className='mb-3'>
          <Form.Label>Email <span style={styles.required}>*</span></Form.Label>
          <Form.Control
            required
            type="email"
            placeholder="you@example.com"
            isValid={validated && isEmail(fields.email)}
            isInvalid={validated && !isEmail(fields.email)}
            onChange={(e) => {
              let value = e.target.value
              setProcessing(true)
              if (isEmail(value)) {
                delayedQuery(value, props.token)
              }
              onChangeFields("email", value)
            }} />
          {/* Checking email availability */}
          {processing && isEmail(fields.email) && (
            <Form.Text className='text-muted d-flex align-items-center gap-1 mt-1'>
              <Spinner animation="border" size="sm" /> Checking email...
            </Form.Text>
          )}
          <Form.Control.Feedback type="invalid">
            Please enter a valid email address.
          </Form.Control.Feedback>
        </Form.Group>

        {/* Password field — only shown for existing users */}
        {!emailNotFound && (
          <Form.Group className='mb-3'>
            <Form.Label>Password <span style={styles.required}>*</span></Form.Label>
            <Form.Control
              required
              value={`${fields.password}`}
              type="password"
              placeholder="Enter your password"
              onChange={(e) => {
                onChangeFields("password", e.target.value)
              }} />
            <Form.Text className="text-muted">
              <ButtonLoading
                style={{ paddingLeft: 0 }}
                className="btn btn-link"
                onClickFetching={async (): Promise<string> => {
                  return await forgotPassword(fields.email)
                }}>
                Forgot Password
              </ButtonLoading>
            </Form.Text>
            <Form.Control.Feedback type="invalid">
              Please enter your password.
            </Form.Control.Feedback>
          </Form.Group>
        )}

        {/* Next button */}
        <div className='mt-3'>
          <ButtonLoading
            customButton={Button}
            customButtonProps={{
              variant: "contained",
              color: "success",
              fullWidth: true,
              size: "large",
            }}
            disabled={processing || !isEmail(fields.email)}
            style={{ width: '100%' }}
            type="submit"
            onClickFetching={async (e): Promise<string> => {
              e.preventDefault();
              e.stopPropagation()
              setValidated(true)
              if (emailNotFound && checkValidity()) {
                setTimeout(() => {
                  props.nextScreen(fields, emailNotFound, null)
                }, 100);
                return "Creating new client."
              }
              if (!checkValidity()) {
                throw new Error("Invalid input data")
              }
              return await submitLogin(fields.email, fields.password)
            }}
            processingComponent={(
              <span className='d-flex align-items-center justify-content-center gap-2'>
                <Spinner animation="border" size="sm" /> Please wait...
              </span>
            )}
            variant="success">
            Next &nbsp;<IosArrowForward color="white" />
          </ButtonLoading>
        </div>

      </Form>
    </div>
  )
}


export default ScreenClientIntro
